// Landing page primary action. Charcoal rather than sage or terracotta: terracotta
// means "overdue" in the reminders shown on the page, and sage is the app's own
// primary, so the signup button gets a color nothing else on the page uses.
export const PRIMARY_CTA =
  'rounded-full bg-foreground text-background hover:bg-foreground/90 active:scale-[0.98] transition-transform'

export const SECONDARY_CTA = 'rounded-full bg-card active:scale-[0.98] transition-transform'

// The global stylesheet removes the browser outline, so anything focusable that
// isn't a <Button> needs this to stay visible to keyboard users. outline-hidden
// (not outline-none) leaves a transparent outline that High Contrast mode paints.
export const FOCUS_RING =
  'focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background'
